module.exports = __webpack_public_path__ + "img/c4b2d16.png";